// Helper to get text from a .txt file
export async function getTextFromDocument(url) {
    if (!url) throw new Error('URL is empty or undefined');

    // Fetch the document
    const response = await fetch(url);

    // If an error occur throw the message
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    // Get the text of the doc
    const text = await response.text();

    // If the file doesn't exist (if the server return index.html)
    if (
        text.trim().startsWith('<!doctype html') ||
        text.trim().startsWith('<html')
    ) {
        throw new Error('File not found');
    }

    // Get the text of the doc adn return it
    return text;
}
